import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import hostsService from './services/hostsService'
import themeService from './services/themeService'
import './assets/css/fonts.css'

// Inicializar Chart.js globalmente
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'

// Registrar componentes do Chart.js globalmente
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

Vue.config.productionTip = false

// Adicionar hostsService como propriedade global
Vue.prototype.$hostsService = hostsService

// Adicionar themeService como propriedade global
Vue.prototype.$themeService = themeService

// Inicializar tema antes de montar a aplicação
const currentTheme = themeService.initializeTheme()

// Aguardar o Vuetify estar pronto antes de definir o tema
if (vuetify && vuetify.theme) {
  vuetify.theme.dark = currentTheme === 'dark'
}

// Criar instância Vue
const app = new Vue({
  router,
  vuetify,
  render: h => h(App),
  mounted() {
    // Garantir que o tema seja aplicado após a montagem
    if (this.$vuetify && this.$vuetify.theme) {
      this.$vuetify.theme.dark = currentTheme === 'dark'
      
      // Aplicar classes CSS correspondentes
      if (document.body) {
        document.body.classList.remove('theme-light', 'theme-dark')
        document.body.classList.add(currentTheme === 'dark' ? 'theme-dark' : 'theme-light')
      }
      
      // Atualizar atributo data-theme
      if (document.documentElement) {
        document.documentElement.setAttribute('data-theme', currentTheme)
      }
    }
  }
})

// Montar a aplicação
app.$mount('#app')